import type { AeTemplateQuestion, AeTemplateSection } from '@/types/assessmentEngine';

export interface TemplateQuestionStats {
  total: number;
  conditional: number;
}

/** Count all questions in the section tree (builder view — no visibility filtering). */
export function countTemplateQuestions(sections: AeTemplateSection[]): TemplateQuestionStats {
  let total = 0;
  let conditional = 0;

  const walk = (list: AeTemplateSection[]) => {
    for (const section of list) {
      for (const q of section.questions) {
        total += 1;
        if (hasShowCondition(q)) conditional += 1;
      }
      walk(section.subsections);
    }
  };

  walk(sections);
  return { total, conditional };
}

export function hasShowCondition(question: AeTemplateQuestion): boolean {
  const meta = question.validation_config as Record<string, unknown> | null | undefined;
  return typeof meta?.show_condition === 'string' && meta.show_condition.trim().length > 0;
}
